import { Component } from '@angular/core';
import { Property as TEntity } from '../../../../../models/entity/property';
import { EntityListCellComponent } from '@shared/components/entity/list/cell/base/base-entity-list-cell.component';
import { ImageComponent } from "@shared/components/image/image.component";

@Component({
  selector: 'website-property-list-cell',
  templateUrl: './property-list-cell.component.html',
  styleUrl: './property-list-cell.component.css',
  imports: [ImageComponent],
})
export class PropertyListCellComponent extends EntityListCellComponent<TEntity> {}
